var _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGettrades(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.2301 23.579C47.0073 23.2172 23.028 30.0918 19.7078 53.9721M56.2301 23.579C30.7752 26.8354 20.4456 43.4793 19.7078 53.9721M56.2301 23.579L58.4436 13.8098M19.7078 53.9721L14.1741 52.8867M14.1741 52.8867C11.2228 56.8667 2.00004 57.2285 2 53.9721C1.99996 50.7157 5.32021 45.2884 14.1741 52.8867ZM58.4436 13.8098C57.3368 10.5534 51.8031 6.2115 56.2301 2.95514C60.657 -0.301216 65.084 5.12608 58.4436 13.8098Z",
    stroke: "white",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.9893,
    y: 30.9894,
    width: 45.5106,
    height: 45.5106,
    rx: 22.7553,
    stroke: "white",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0747,
    y: 39.0745,
    width: 29.3404,
    height: 29.3404,
    rx: 14.6702,
    stroke: "white",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettrades);
export default __webpack_public_path__ + "static/media/Gettrades.8742853342920620f409276d30cef36e.svg";
export { ForwardRef as ReactComponent };